import { Component, inject, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { decompress } from 'lz-string';
import { BaseComponent } from '../base-component/base.component';
import { ExcelObject, formatAsDateOptions, UtilService } from 'src/app/services/util.service';
import { utils, writeFile } from 'xlsx';
import { DatePipe } from '@angular/common';
import { LoadingService } from 'src/app/services/loading.service';
import { DeviceInfoService, TABLET_RESOLUTION_CUTOFF } from 'src/app/services/device-info.service';
import { translateDateForSQLServer, translateDateForWebISO } from 'src/app/Utility/date_functions/SQL_ISO_adapter';
import { BehaviorSubject, combineLatest, map, startWith } from 'rxjs';
import { VisitClient } from 'src/app/Interfaces/SQL-reports-responses';

type Active = VisitClient & {
	Client_Name: string;
	string?: any;
	ResonVisitText?: string;
	Ldt?: string;
	PicName?: string;
};

type ActiveWithCustomFields = Omit<Active, 'string'> & {
	string: {
		date: string;
		clientName: string;
		contactName: string;
		subject: string;
		city: string;
		handledBy: string;
		reasonOf: string;
		details: string;
		Enter: string;
		Exit: string;
	};
};

type RadioValues = 'basic' | 'detailed';
@Component({
	selector: 'app-adminactiv',
	templateUrl: './adminactiv.component.html',
	styleUrls: ['./adminactiv.component.scss'],
})
export class AdminactivComponent extends BaseComponent implements OnInit {
	_util = inject(UtilService);
	_device = inject(DeviceInfoService);
	private _loading = inject(LoadingService);
	private acr = inject(ActivatedRoute);
	private fb = inject(FormBuilder);
	private router = inject(Router);

	constructor() {
		super();
	}

	form = this.fb.group({
		Agent: ['all'],
		// Date: [<string[]>[], Validators.required],
		from: [<Date>null],
		to: [<Date>null],
		Name: ['all'],
	});
	formValues$ = this.form.valueChanges.pipe(startWith(this.form.value));
	burgerMenu = false;
	burgerMenuNoScroll = false;
	headerAbsolute = false;

	public Agents;
	public AllClients;
	public AllClientsName;
	public AllClientsSearch;

	agentsToGet = [];

	public Dates: string[] = [];
	public Names = [];
	agents = [];
	dateFilterFunction = (date: Date): boolean => {
		const dates = this.Dates;

		return date ? dates.includes(translateDateForSQLServer(date).toISOString().slice(0, 10)) : false;
	};

	isAdmin = location.pathname.includes('admin');
	hasString = false;
	hasReasonVisitText = false;

	isPopupOpen = false;
	selectedActive: Active | ActiveWithCustomFields | null = null;

	hasAtLeastOneActiveWithCustomFieldsAndClientName = false;

	windowWidth = innerWidth;

	shouldFilterByClient = this.acr.snapshot.queryParams['clientid'];

	radioControl = new FormControl<RadioValues>('basic');

	isTabletAndUpResolution = this._device.windowWidth$.value >= TABLET_RESOLUTION_CUTOFF;

	showFilterPopup = false;

	hasVisitsPictures = false;

	visits$ = new BehaviorSubject<Active[]>([]);
	visitsDisplay$ = combineLatest([this.visits$, this.formValues$]).pipe(
		map(([visits, formValues]) => {
			if (formValues.Name !== 'all') {
				visits = visits.filter(v => v.ClientID === formValues.Name);
			}

			if (formValues.Agent !== 'all') {
				visits = visits.filter(v => v.AgentID === formValues.Agent);
			}

			if (formValues.from && formValues.to) {
				const { from, to } = formValues;
				if (from.getTime() === to.getTime()) {
					visits = visits.filter(v => v.CreateDate.slice(0, 10) === translateDateForSQLServer(formValues.from).toISOString().slice(0, 10));
				} else {
					const startOfDay = from.getTime();
					const endOfDay = translateDateForSQLServer(new Date(to.getTime() + 86400000)).getTime();
					visits = visits.filter(v => translateDateForWebISO(v.CreateDate).getTime() >= startOfDay && translateDateForWebISO(v.CreateDate).getTime() <= endOfDay);
				}
			}

			return visits;
		}),
	);

	ngOnInit(): void {
		if (localStorage.getItem('UserName') !== null && localStorage.getItem('AgentId') !== null) {
			this._ss.UserNameConnected = localStorage.getItem('UserName');
			this._ss.AgentIdConnected = localStorage.getItem('AgentId');
		} else {
			this.router.navigate(['login']);
			return;
		}

		this._ss.allVisitsAdmin().subscribe({
			next: async res => {
				if (typeof res === 'string') {
					alert('לא ניתן להביא ביקורים');
					history.back();
					return;
				}

				this.AllClients = res.recordset;
				this.visits$.next(this.AllClients);

				let anyPictures = false;

				for (const visit of this.AllClients) {
					try {
						if ('DATAString' in visit && visit.DATAString) {
							const data = JSON.parse(visit.DATAString);
							if (data.PicName && data.PicName !== '0') {
								anyPictures = true;
								visit.PicName = data.PicName;
							}
						}
					} catch (err) {}
				}

				this.hasVisitsPictures = anyPictures;

				if (this._ss.CustomerInformation?.VisitsTakePicture !== '1') {
					this.hasVisitsPictures = false;
				}

				if (!this.isAdmin) {
					this.AllClients = this.AllClients.filter(ac => ac.AgentID === this._ss.AgentIdConnected);
					this.visits$.next(this.AllClients);
				}

				await new Promise<void>(resolve => {
					this._ss.GetAllReportsAgentReasons(1).subscribe({
						next: (res: any) => {
							if (!res.recordset) return resolve();
							const reasons = res.recordset.filter(r => [2, 3].includes(r.rem));

							if (reasons.length) {
								for (const client of this.AllClients) {
									if (client.DATAString) {
										this.hasString = true;
										const string = JSON.parse(client.DATAString);
										const reason = reasons.find(rs => rs.rid === string.ResonVisitID);
										if (reason) {
											client.ResonVisitText = reason.rds;
											this.hasReasonVisitText = true;
										}
									}
								}
							}
							resolve();
						},
						error: err => {
							resolve();
						},
					});
				});

				if (localStorage.getItem('AllClients') !== null) {
					this.AllClientsName = decompress(localStorage.getItem('AllClients'));
					this.AllClientsName = JSON.parse(this.AllClientsName);

					for (let x = 0; x < this.AllClientsName.length; x++) {
						for (let y = 0; y < this.AllClients.length; y++) {
							this.AllClients[y].ClientId = this.AllClients[y].ClientID;
							if (this.AllClientsName[x].ClientId === this.AllClients[y].ClientID) {
								if (this.AllClientsName[x].Ldt) {
									this.AllClients[y].Ldt = this.AllClientsName[x].Ldt;
								}
								if (!this.AllClients[y].ClientName && this.AllClientsName[x].Client_Name) {
									this.AllClients[y].Client_Name = this.AllClients[y].ClientName = this.AllClientsName[x].Client_Name;
								} else {
									this.AllClients[y].Client_Name = this.AllClients[y].ClientName;
								}
							}
							try {
								this.AllClients[y].string = JSON.parse(this.AllClients[y].DATAString || '{}');
								if ('Enter' in this.AllClients[y].string && 'Exit' in this.AllClients[y].string) {
									this.hasString = true;
								}
							} catch (err) {
								this.AllClients[y].string = '';
							}
							// replace "" if exists in string. might be unnecessarily complex
							this.AllClients[y].string.Exit &&= this.AllClients[y].string.Exit.replaceAll('"', '');
						}
					}

					this.AllClientsSearch = this.AllClients;

					const hashTables = {
						Agents: {} as Record<string, string>,
						Dates: new Set<string>(),
						Names: {} as Record<string, string>,
					};

					for (const client of this.AllClientsSearch) {
						hashTables.Agents[client.AgentID] = client.UserName;
						hashTables.Dates.add(client.CreateDate.toString().slice(0, 10));
						hashTables.Names[client.ClientID] = client.ClientName ?? client.Client_Name ?? '';
					}

					this.hasAtLeastOneActiveWithCustomFieldsAndClientName = this.AllClientsSearch.some(client => this.isActiveWithCustomFields(client) && client.string.clientName);

					this.Agents = Object.entries(hashTables.Agents).map(([AgentID, UserName]) => ({ AgentID, UserName }));
					this.Dates = [...hashTables.Dates].sort((a, b) => new Date(translateDateForWebISO(a)).getTime() - new Date(translateDateForWebISO(b)).getTime());
					this.Names = Object.entries(hashTables.Names).map(([ClientID, Client_Name]) => ({ ClientID, Client_Name }));
				}

				if (this.isAdmin) {
					this.handleGetAgents();
				}

				if (this.shouldFilterByClient) {
					this.form.controls.Name.setValue(this.shouldFilterByClient);
				}
			},
			error: () => {
				alert('לא ניתן ליצור קשר עם השרת, נסו שנית מאוחר יותר');
				history.back();
			},
		});
	}

	public BackToAdmin() {
		history.back();
	}

	handleGetAgents() {
		if (this._ss.CustomerInformation.Submanagers == '1') {
			if (!this._ss.agentsOfSubmanager.length) {
				this._ss.getAdminAgents().subscribe({
					next: res => {
						if (typeof res == 'string') {
							alert('חלה תקלה בהבאת סוכנים עבור מנהל זה. נסו שנית');
							return;
						}

						this.agentsToGet = res.recordset.map(obj => obj.Agent);
						this.agentsToGet.push(this._ss.AgentIdConnected);

						this.getAgentList();
					},
					error: err => {
						alert('שגיאת שרת');
						history.back();
					},
				});
			} else {
				this.agentsToGet = this._ss.agentsOfSubmanager;
				this.getAgentList();
			}
		} else {
			this.getAgentList();
		}
	}

	getAgentList() {
		this._ss.GetAllAgents(this.agentsToGet).subscribe(res => {
			if (typeof res === 'string') {
				alert('לא ניתן להביא סוכנים');
				history.back();
				return;
			}

			if (this._ss.CustomerInformation.Submanagers === '1') {
				const allowedAgents = new Set(this.Agents.map(ag => ag.AgentID));

				this.AllClientsSearch = this.AllClientsSearch.filter(client => allowedAgents.has(client.AgentID));
				this.AllClients = this.AllClients.filter(client => allowedAgents.has(client.AgentID));
				this.Agents = this.Agents.filter(ag => allowedAgents.has(ag.AgentID));

				this.visits$.next(this.AllClients);
			}

			for (let i = 0; i < res.recordset.length; i++) {
				const agent = this.Agents.find(ag => ag.AgentID === res.recordset[i].AgentID);
				if (agent) {
					agent.UserName = res.recordset[i].UserName;
				}
			}

			this._loading.changeLoadingStatuses({ isLoading: false });
		});
	}

	openPopup(activ: Active) {
		this.selectedActive = activ;
		this.isPopupOpen = true;
	}

	handleClosePopup() {
		this.isPopupOpen = false;
		this.selectedActive = null;
	}

	valuesObject = {
		First: ['Client_Name', 'AgentID', 'ClientID', 'CreateDate', 'CreateDate', 'ResDesc', 'Remark', 'ResonVisitText'],
	} as const;

	translateForSort(value: typeof this.valuesObject[typeof screen][number], screen: keyof typeof this.valuesObject = Object.keys(this.valuesObject)[0] as keyof typeof this.valuesObject): void {
		let i: number, arrayToSort: any[];

		i = this.valuesObject[screen].findIndex(arr => arr === value);

		if (screen === 'First') {
			arrayToSort = this.AllClients;
		}

		if (i === undefined || i === -1) {
			console.log('i should never show');
			return;
		}

		this._util.sortWithIndex(value, i, arrayToSort);
	}

	downloadExcel() {
		const dataObject: ExcelObject = { data: [], filename: '', extension: 'xlsx' };

		const getFormatOptions = (str: 'date' | 'hour'): formatAsDateOptions => ({ isTrueISO: true, onlyTime: str === 'hour' });

		console.log(this.AllClients);

		const longestStringInColumn: any = {};
		const isAdmin = location.pathname.includes('admin');

		dataObject.data = this.AllClients.map(b => {
			const obj: { [key: string]: string | number } = {
				תאריך: this._util.formatAsDate(b.CreateDate, getFormatOptions('date')),
				לקוח: b.Client_Name ?? b.ClientName,
				'סיכום ביקור': b.ResDesc,
			};
			if (isAdmin) {
				obj['סוכן'] = b.AgentID;
			}

			if (this.radioControl.value === 'detailed') {
				obj['קוד לקוח'] = b.ClientID;
				obj['פירוט'] = b.Remark;
				if (!this.hasString) {
					obj['שעה'] = this._util.formatAsDate(b.CreateDate, getFormatOptions('hour'));
				} else {
					obj['כניסה'] = b.string.Enter ? this._util.formatAsDate(b.string.Enter, getFormatOptions('hour')) : 'לא קיים נתון';
					obj['יציאה'] = b.string.Exit ? this._util.formatAsDate(b.string.Exit, getFormatOptions('hour')) : 'לא קיים נתון';
				}

				if (this.hasReasonVisitText) {
					obj['סיבת ביקור'] = b.ResonVisitText;
				}
			}

			for (const entry of Object.entries(obj)) {
				longestStringInColumn[entry[0]] ??= 0;
				longestStringInColumn[entry[0]] = Math.max(String(entry[1]).length, longestStringInColumn[entry[0]], 3);
			}
			return obj;
		});

		dataObject.filename = 'ביקורים';

		const ws = utils.json_to_sheet(dataObject.data);

		ws['!cols'] = Object.values(longestStringInColumn).map((columnWidth: number) => ({ wch: columnWidth }));

		const wb = utils.book_new();
		if (!wb.Workbook) wb.Workbook = {};
		if (!wb.Workbook.Names) wb.Workbook.Views = [{}];
		wb.Workbook.Views[0].RTL = true;
		utils.book_append_sheet(wb, ws, dataObject.filename);
		writeFile(wb, `${dataObject.filename}.${dataObject.extension}`, { bookType: dataObject.extension, sheet: dataObject.filename, compression: true, cellStyles: true });
	}

	trackBy(index: number, visit: Active): string {
		return visit.VisitID;
	}

	resetFilters() {
		this.form.setValue({
			Agent: 'all',
			from: null,
			to: null,
			Name: 'all',
		});
	}

	isActiveWithCustomFields(visit: Active | ActiveWithCustomFields): visit is ActiveWithCustomFields {
		return 'string' in visit && 'date' in visit.string;
	}
}
